import { changeList } from './request';
import { customerResource } from './../../system/customerManage/request';
import { applicationResource } from './../../customer/applicationManage/request';
import processModel from './processModel.vue';
export default {
  components: {
    processModel
  },
  data() {
    return {
      processShow: false,
      form: {
        applicationId: undefined
      },
      data: [],
      columns: [{
        slots: {
          title: '序号'
        },
        dataIndex: 'index',
        key: '1',
        align: 'center',
        scopedSlots: {
          customRender: 'index'
        },
        width: 80
      }, {
        slots: {
          title: 'ID'
        },
        dataIndex: 'reviewNodeId',
        key: '2',
        align: 'center'
      }, {
        slots: {
          title: '发布客户'
        },
        dataIndex: 'customerName',
        key: '3',
        align: 'center'
      }, {
        slots: {
          title: '客户应用'
        },
        dataIndex: 'appName',
        key: '4',
        align: 'center'
      }, {
        slots: {
          title: '产品标识'
        },
        dataIndex: 'insuranceMark',
        key: '5',
        align: 'center'
      }, {
        slots: {
          title: '产品名称'
        },
        dataIndex: 'customerInsuranceName',
        key: '6',
        align: 'center'
      }, {
        slots: {
          title: '申请人'
        },
        dataIndex: 'userName',
        key: '7',
        align: 'center'
      }, {
        slots: {
          title: '审核状态'
        },
        dataIndex: 'statusName',
        key: '10',
        align: 'center',
        scopedSlots: {
          customRender: 'statusName'
        }
      }, {
        slots: {
          title: '申请时间'
        },
        dataIndex: 'createAt',
        key: '8',
        align: 'center',
        width: 180
      }, {
        slots: {
          title: '操作'
        },
        scopedSlots: {
          customRender: 'action'
        },
        align: 'center',
        key: '9',
        align: 'center',
        width: 210
      }],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      customerList: [],
      applicationList: []
    };
  },
  created() {
    console.log(JSON.stringify(this.columns));
    customerResource().then(res => {
      this.customerList = res;
    });
    this.getDataFun();
  },
  methods: {
    applicationFun() {
      this.form.applicationId = undefined;
      applicationResource({
        customerId: this.form.customerId
      }).then(res => {
        this.applicationList = res;
      });
    },
    getDataFun() {
      let obj = this.form;
      obj.page = this.pagination.current;
      obj.pageSize = this.pagination.pageSize;
      changeList(obj).then(res => {
        console.log(res);
        this.data = res.items;
        this.pagination.total = res.totalNum;
      });
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getTableFun();
    },
    handleSee(val) {
      this.processShow = true;
      this.$nextTick(() => {
        this.$refs.processFrom.init(val);
      });
    },
    searchFun() {
      this.pagination.current = 1;
      this.getDataFun();
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
  }
};